export interface ModalModel {
  showModal: boolean;
  title: string;
  message: string;
}
